import { SkyMilesStatus } from '@com-delta-omnichannel/aura';

export const DiamondMedallionBannerStatusMocks: SkyMilesStatus = {
  priority: {
    active: false,
    label: '',
    url: ''
  },
  tier: {
    title: 'CURRENT STATUS: ',
    subtitle: 'DIAMOND MEDALLION®',
    level: '0',
    name: 'diamond'
  },
  enrollDate: 'SKYMILES MEMBER SINCE 2004'
};
